// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3HpXg","colMin":"styles_colMin__2mMdb","colCheckbox":"styles_colCheckbox__2z11P"};